import { FieldValues } from 'react-hook-form';

import { ALL_COUNTRY_CODES_MAP, TWO_LETTER_COUNTRY_CODES } from '@willow/types-iso';

import { ControlledSimpleSelect, ControlledSimpleSelectProps } from './ControlledSimpleSelect';

const OPTIONS = [
  ...TWO_LETTER_COUNTRY_CODES.map((countryCode) => ({
    value: countryCode,
    label: `${ALL_COUNTRY_CODES_MAP[countryCode]} (${countryCode})`,
  })),
];

type Props<T extends FieldValues> = Omit<ControlledSimpleSelectProps<T>, 'options'>;

export function ControlledCountrySelect<T extends FieldValues>({ control, fieldName, required, ...props }: Props<T>) {
  return (
    <ControlledSimpleSelect {...props} options={OPTIONS} control={control} fieldName={fieldName} required={required} />
  );
}
